import "@jsq/ds/index.css";
import React from "react";
import { render } from "react-dom";
import { initObservability } from "common/utils/o11y";
import { getSingletonReactRoot } from "./App/utils";

initObservability({ appName: "gp" });

async function loadApp() {
  const loader = await import(/* webpackChunkName: "App" */ "./App");
  return loader.App;
}

function renderPillars() {
  const reactRoot = getSingletonReactRoot();
  loadApp().then((App) => {
    render(<App />, reactRoot);
  });
}

type JsqPillarsGlobalThis = typeof globalThis & {
  __jsqRenderPillars__?: typeof renderPillars;
};

// eslint-disable-next-line no-underscore-dangle
(globalThis as JsqPillarsGlobalThis).__jsqRenderPillars__ = renderPillars;

renderPillars();
